/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zippy_Day_Bullock_WaveInputs */

const fr_zippy_day_bullock_wave = /** @type {(inputs: Zippy_Day_Bullock_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max (kg)`)
};

/**

* @param {Zippy_Day_Bullock_WaveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zippy_day_bullock_wave = /** @type {((inputs?: Zippy_Day_Bullock_WaveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zippy_Day_Bullock_WaveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zippy_day_bullock_wave(inputs)
});